const BookmarkedSvg = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3334 1.66666H6.66675C6.00371 1.66666 5.36783 1.93006 4.89899 2.3989C4.43015 2.86774 4.16675 3.50362 4.16675 4.16666V17.5C4.16617 17.6468 4.2044 17.7912 4.27757 17.9185C4.35074 18.0459 4.45625 18.1516 4.58342 18.225C4.7101 18.2981 4.85381 18.3366 5.00009 18.3366C5.14637 18.3366 5.29007 18.2981 5.41675 18.225L10.0001 15.575L14.5834 18.225C14.7104 18.297 14.8541 18.3343 15.0001 18.3333C15.1461 18.3343 15.2898 18.297 15.4168 18.225C15.5439 18.1516 15.6494 18.0459 15.7226 17.9185C15.7958 17.7912 15.834 17.6468 15.8334 17.5V4.16666C15.8334 3.50362 15.57 2.86774 15.1012 2.3989C14.6323 1.93006 13.9965 1.66666 13.3334 1.66666Z"
        fill="#282F33"
      />
    </svg>
  );
};
export default BookmarkedSvg;
